export enum  Sortingfield {
    probability = 'probability',
    DWT = 'DWT',
    eta_time = 'eta_time'
}